import { useEffect } from 'react';
import { useDispatch } from 'dva';

export default function ({ children }) {
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatch({
        type: 'StaffList/reset',
      });
    };
  }, []);
  return children;
}
